<section>
  <div class="pane-content container-fluid">
    <div class="center" style="margin:10px" *ngIf="configFormIndex===1">
      <form>
        <div class="form-group">
          <label for="productName">Product Name</label>
          <input type="text"
                 class="form-control"
                 id="productName"
                 name="productName"
                 [(ngModel)]="previewModel.productName">
        </div>
        <div class="form-group">
          <label for="productCode">Product Code</label>
          <input type="text"
                 class="form-control"
                 id="productCode"
                 name="productCode"
                 [(ngModel)]="previewModel.productCode">
        </div>
        <div class="form-group">
          <label for="productDescription">Product Description</label>
          <input type="text"
                 class="form-control"
                 id="productDescription"
                 name="productDescription"
                 [(ngModel)]="previewModel.productDescription">
        </div>
        <div class="form-group">
          <kendo-switch onLabel="Yes"
                        offLabel="No"
                        name="bypassBaseConfig"
                        [(ngModel)]="previewModel.bypassBaseConfig">
          </kendo-switch>&nbsp;
          <label class="k-checkbox-label">Bypass Base Config</label>
        </div>
        <div class="form-group">
          <label for="productNameExpression">Configuration Name Expression</label>
          <kendo-dropdownlist class="kendoInput form-control"
                              [data]="macroList"
                              textField="name"
                              valueField="name"
                              id="productNameExpression">
          </kendo-dropdownlist>
        </div>
        <div class="form-group">
          <label for="configAttribute">Product Attribute</label>
          <div class="input-group mb-3">
            <kendo-dropdownlist #selectedProductAttributeTemp class="kendoInput form-control"
                                id="configAttribute"
                                [data]="attributeList"
                                [(ngModel)]="selectedProductAttribute"
                                name="productAttributeList"
                                textField="name"
                                valueField="name">
            </kendo-dropdownlist>
            <div class="input-group-append">
              <span class="k-icon k-i-plus k-icon-size"
                    style="color: green; font-size: 32px;"
                    (click)="addProductAttribute(selectedProductAttributeTemp)"
                    title="Add Attribute"></span>
            </div>
          </div>
        </div>

        <div class="form-row" *ngFor="let pAttr of previewModel.productAttributes;let pAttrIndex=index">
          <div class="input-group mb-3">
            <input type="text" class="form-control" value="{{pAttr.name}}" disabled />
            <div class="input-group-append">
              <span class="k-icon k-i-minus k-icon-size" style="color: red;" (click)="removeProductAttribute(pAttrIndex)"
                    title="Delete"></span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="bp2Macro">BP1 Macros</label>
          <div class="input-group mb-3">
            <kendo-dropdownlist #selectedBP1MacroTemp class="kendoInput form-control"
                                id="bp1Macro"
                                [data]="macroList"
                                [(ngModel)]="selectedBP1Macro"
                                name="bp1MacroList"
                                textField="name"
                                valueField="name">
            </kendo-dropdownlist>
            <div class="input-group-append">
              <span class="k-icon k-i-plus k-icon-size"
                    style="color: green; font-size: 32px;"
                    (click)="addBP1Macro(selectedBP1MacroTemp)"
                    title="Add BP1 Macro"></span>
            </div>
          </div>
        </div>

        <div class="form-row" *ngFor="let bp1Macro of previewModel.bp1Macros;let bp1MacroIndex=index">
          <div class="input-group mb-3">
            <input type="text" class="form-control" value="{{bp1Macro.name}}" disabled />
            <div class="input-group-append">
              <span class="k-icon k-i-minus k-icon-size" style="color: red;" (click)="removeBP1Macro(bp1MacroIndex)"
                    title="Delete"></span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="bp2Macro">BP2 Macros</label>
          <div class="input-group mb-3">
            <kendo-dropdownlist #selectedBP2MacroTemp class="kendoInput form-control"
                                id="bp2Macro"
                                [data]="macroList"
                                [(ngModel)]="selectedBP2Macro"
                                name="bp2MacroList"
                                textField="name"
                                valueField="name">
            </kendo-dropdownlist>
            <div class="input-group-append">
              <span class="k-icon k-i-plus k-icon-size"
                    style="color: green; font-size: 32px;"
                    (click)="addBP2Macro(selectedBP2MacroTemp)"
                    title="Add BP2Macro"></span>
            </div>
          </div>
        </div>

        <div class="form-row" *ngFor="let bp2Macro of previewModel.bp2Macros;let bp2MacroIndex=index">
          <div class="input-group mb-3">
            <input type="text" class="form-control" value="{{bp2Macro.name}}" disabled />
            <div class="input-group-append">
              <span class="k-icon k-i-minus k-icon-size" style="color: red;" (click)="removeBP2Macro(bp2MacroIndex)"
                    title="Delete"></span>
            </div>
          </div>
        </div>
        <button class="m-3 clearKendoButton btn btn-success"
                (click)="goTo(2)"
                kendoButton>
          Manage Frames
        </button>
        <button class="m-3 clearKendoButton btn btn-success"
                (click)="saveConfig()"
                kendoButton>
          Save
        </button>
        <button class="m-3 clearKendoButton btn btn-success"
                (click)="resetConfig()"
                kendoButton>
          Reset
        </button>
        <button class="m-3 clearKendoButton btn btn-success"
                (click)="saveToDatabaseConfig()"
                kendoButton>
          Save To Database
        </button>
        <button class="m-3 clearKendoButton btn btn-success"
                [routerLink]="['/manageProduct']"
                kendoButton>
          Back
        </button>
      </form>
    </div>
    <div class="center" style="margin:10px" *ngIf="configFormIndex===2">
      <kendo-card [width]="'100%'" style="margin:10px;">
        <kendo-card-header class="k-hbox">
          <div>
            <h1 kendoCardTitle>Resource Frame</h1>
          </div>
        </kendo-card-header>
        <kendo-card-body>
          <div class="input-group mb-3" *ngIf="previewModel?.resourceFrame?.name?.length>0">
            <input type="text" class="form-control" value="{{previewModel?.resourceFrame?.name}}" disabled>
            <div class="input-group-append">
              <button class="clearKendoButton btn btn-success"
                      (click)="editResourceFrame()"
                      kendoButton>
                Edit
              </button>
            </div>
          </div>
          <div class="input-group mb-3" *ngIf="previewModel?.resourceFrame?.name?.length===0">
            <button class="clearKendoButton btn btn-success"
                    (click)="addResourceFrame()"
                    kendoButton>
              Add Resource Frame
            </button>
          </div>
        </kendo-card-body>
      </kendo-card>
      <kendo-card [width]="'100%'" style="margin:10px;">
        <kendo-card-header class="k-hbox">
          <div>
            <h1 kendoCardTitle>Nested Frames</h1>
          </div>
        </kendo-card-header>
        <kendo-card-body>
          <div class="row" *ngFor="let nestedFrame of previewModel.nestedFrames;let nestedFrameIndex=index;" style="margin:10px;">

            <div class="input-group mb-3">
              <input type="text" class="form-control" value="{{nestedFrame.name}}" disabled>
              <div class="input-group-append">
                <button class="clearKendoButton btn btn-success"
                        (click)="editNestedFrame(nestedFrameIndex)"
                        kendoButton>
                  Edit
                </button>
              </div>
            </div>
          </div>
          <button class="clearKendoButton btn btn-success"
                  (click)="addNestedFrame()"
                  kendoButton>
            Add Nested Frame
          </button>

        </kendo-card-body>
      </kendo-card>
      <button class="m-3 clearKendoButton btn btn-success"
              (click)="goTo(1)"
              kendoButton>
        Back
      </button>
    </div>
    <div *ngIf="configFormIndex===3" class="center" style="margin:10px">
      <kendo-card [width]="'100%'">
        <kendo-card-header class="k-hbox">
          <div *ngIf="frameEditingSteps===1 || frameEditingSteps===2">
            <h1 kendoCardTitle>Edit Frame</h1>
          </div>
          <div *ngIf="frameEditingSteps===0 || frameEditingSteps===3">
            <h1 kendoCardTitle>Add Frame</h1>
          </div>
        </kendo-card-header>
        <kendo-card-body>
          <form>
            <div>

              <div class="form-group">
                <label for="frameName">Frame Name</label>
                <input type="text"
                       class="form-control"
                       id="frameName"
                       [(ngModel)]="frameInEditMode.name"
                       name="frameName">

              </div>

              <div class="form-group">
                <label for="frameCodePrefix">Code Prefix</label>
                <input type="text"
                       class="form-control"
                       id="frameCodePrefix"
                       [(ngModel)]="frameInEditMode.codePrefix"
                       name="frameCodePefix">
              </div>
              <hr />
              <div class="form-group">
                <label for="frameSelection">Frame Selection</label>
                <div class="row">
                  <div class="col-md-6">
                    Frame Code
                  </div>
                  <div class="col-md-6">
                    Attribute Filter
                  </div>
                </div>
                <hr />
                <div class="form-group">
                  <label for="frameAttribute">Attribute Filter</label>
                  <div class="input-group mb-3">
                    <kendo-dropdownlist class="kendoInput form-control k-width"
                                        id="frameAttribute"
                                        [data]="attributeList"
                                        [(ngModel)]="selectedFrameAttribute"
                                        name="frameAttribute"
                                        textField="name"
                                        valueField="name">
                    </kendo-dropdownlist>
                    <div class="input-group-append">
                      <span class="k-icon k-i-plus k-icon-size"
                            style="color: green;"
                            (click)="addFrameAttribute()"
                            title="Add Attribute"></span>
                    </div>
                  </div>
                </div>
                <div class="form-row" *ngFor="let attr of frameInEditMode.attributeFilters;let pAttrIndex=index">
                  <div class="input-group mb-3">
                    <input type="text" class="form-control" value="{{attr.name}}" disabled />
                    <div class="input-group-append">
                      <span class="k-icon k-i-minus k-icon-size" style="color: red;"
                            (click)="removeFrameAttribute(pAttrIndex,attr)"
                            title="Delete"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </form>
        </kendo-card-body>
      </kendo-card>
      <button class="m-3 clearKendoButton btn btn-success"
              (click)="saveFrame()"
              kendoButton>
        Save Frame
      </button>
      <button class="m-3 clearKendoButton btn btn-success"
              (click)="goTo(2)"
              kendoButton>
        Cancel
      </button>
    </div>

  </div>
</section>
